import './AboutUs.css'
import Location from '../Location/Location.js'

export default function AboutUs() {
    return(
        <div className="aboutusContainer container ">
            <h4>About Us</h4>
            <p> Mission to provide the real camping experience. </p>
            <Location/>
        </div>
    );
}
